import api from '../lib/api';

const disputeService = {
    // Get auctions available for dispute filing
    getDisputableAuctions: async () => {
        try {
            const response = await api.get('/disputes/disputable-auctions');
            return response.data;
        } catch (error) {
            console.error('Error fetching disputable auctions:', error);
            throw error;
        }
    },

    // Get disputable lots for a specific auction
    getDisputableLots: async (auctionSlug) => {
        try {
            const response = await api.get(`/disputes/disputable-lots/${auctionSlug}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching disputable lots:', error);
            throw error;
        }
    },

    // Get all disputes for the authenticated user
    getDisputes: async (params = {}) => {
        try {
            const response = await api.get('/disputes', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching disputes:', error);
            throw error;
        }
    },

    // Get a single dispute
    getDispute: async (disputeId) => {
        try {
            const response = await api.get(`/disputes/${disputeId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching dispute:', error);
            throw error;
        }
    },

    // Create a new dispute
    createDispute: async (disputeData) => {
        try {
            const response = await api.post('/disputes', disputeData);
            return response.data;
        } catch (error) {
            console.error('Error creating dispute:', error);
            throw error;
        }
    },

    // Add a message to a dispute
    addMessage: async (disputeId, message) => {
        try {
            const response = await api.post(`/disputes/${disputeId}/messages`, { message });
            return response.data;
        } catch (error) {
            console.error('Error adding message:', error);
            throw error;
        }
    },

    // Cancel a dispute
    cancelDispute: async (disputeId) => {
        try {
            const response = await api.post(`/disputes/${disputeId}/cancel`);
            return response.data;
        } catch (error) {
            console.error('Error cancelling dispute:', error);
            throw error;
        }
    },

    // Admin: Get all disputes
    adminGetDisputes: async (params = {}) => {
        try {
            const response = await api.get('/admin/disputes', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching admin disputes:', error);
            throw error;
        }
    },

    // Admin: Get dispute statistics
    adminGetStatistics: async () => {
        try {
            const response = await api.get('/admin/disputes/statistics');
            return response.data;
        } catch (error) {
            console.error('Error fetching dispute statistics:', error);
            throw error;
        }
    },

    // Admin: Assign dispute to admin
    adminAssignDispute: async (disputeId, adminId) => {
        try {
            const response = await api.post(`/admin/disputes/${disputeId}/assign`, { admin_id: adminId });
            return response.data;
        } catch (error) {
            console.error('Error assigning dispute:', error);
            throw error;
        }
    },

    // Admin: Update dispute status
    adminUpdateStatus: async (disputeId, status) => {
        try {
            const response = await api.post(`/admin/disputes/${disputeId}/status`, { status });
            return response.data;
        } catch (error) {
            console.error('Error updating dispute status:', error);
            throw error;
        }
    },

    // Admin: Resolve dispute
    adminResolveDispute: async (disputeId, resolutionData) => {
        try {
            const response = await api.post(`/admin/disputes/${disputeId}/resolve`, resolutionData);
            return response.data;
        } catch (error) {
            console.error('Error resolving dispute:', error);
            throw error;
        }
    },

    // Admin: Update dispute priority
    adminUpdatePriority: async (disputeId, priority) => {
        try {
            const response = await api.post(`/admin/disputes/${disputeId}/priority`, { priority });
            return response.data;
        } catch (error) {
            console.error('Error updating dispute priority:', error);
            throw error;
        }
    },
};

export default disputeService;

